import { render, staticRenderFns } from "./table-body.vue?vue&type=template&id=5f6ae79c&"
import script from "./table-body.vue?vue&type=script&lang=js&"
export * from "./table-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6ae79c')) {
      api.createRecord('5f6ae79c', component.options)
    } else {
      api.reload('5f6ae79c', component.options)
    }
    module.hot.accept("./table-body.vue?vue&type=template&id=5f6ae79c&", function () {
      api.rerender('5f6ae79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/table-body.vue"
export default component.exports